export default {
    'invoice-no': 'رقم الفاتورة',
    new: 'جديد',
    delete: 'حذف',
    account: 'الحساب',
    'invoice-date': 'تاريخ الفاتورة',
    warehouse: 'المستودع',
    document: 'المستند',
    'net-invoice': 'صافي الفاتورة',
    edit: 'تعديل',
    save: 'حفظ',
    not: 'غير',
    posted: 'مُرحّلة',
    'add-invoice': 'إضافة فاتورة',
    notes: 'ملاحظات',
    'account-trade-config': 'حساب المشتريات',
    create: 'إنشاء',
    cancel: 'إلغاء',
    'choose-serial-number-alert': "إنذار الرقم التسلسلي",
    'choose-serial-number-alert-content': 'لقد قمت ب إضافة رقم تسلسلي تم استخدامه بالفعل لمادة أخرى هل أنت متأكد من استخدامه؟',
    'delete-entry': 'حذف سطر',
    'are-you-sure-you-want-to-delete-the-entry': 'هل أنت متأكد من حذف السطر؟',
    'add-serial-number': "إضافة رقم تسلسلي",
    'serial-number': 'الرقم تسلسلي',
    "serial-numbers": "الأرقام التسلسلية",
    'delete-invoice': 'حذف الفاتورة',
    'are-you-sure-you-want-to-delete-the-invoice-that-will-delete-the-associated-bond': 'هل أنت متأكد من حذف الفاتورة سيتم حذف السند المُرتبط أيضاً؟',
    discount: 'الحسم',
    total: 'الإجمالي',

    headers: {
        no: 'الرقم',
        warehouse: 'المستودع',
        material: 'المادة',
        quantity: 'الكمية',
        count: 'العدد',
        price: 'السعر',
        'total-amount': 'صافي القيمة',
        'notes': 'الملاحظات',
        'delivery-status': 'حالة تسليم المادة'
    },

    'context-menu': {
        edit: 'تعديل',
        delete: 'حذف'
    },
    payments: 'المدفوعات',
    'total-payments': 'المدفوعات',
    'alert-message': 'رسالة تنبيه',
    'confirm-message': 'أصبح مجموع المقبوضات أكبر من الإجمالي. هل تريد المتابعة ؟',
    'total-expenses': 'المصاريف',
    'expenses': 'المصاريف',

    'confirm-dialog-title': 'تنبيه: بيانات غير مكتملة',
    'confirm-dialog-content': 'لقد قمت بإدخال معلومات غير مكتملة. لذا، لن يتم حفظ القيد الأخير الذي قمت بإضافته',
    'confirm-dialog-actions': {
        confirm: 'حفظ الفاتورة وتجاهل القيد',
        cancel: 'إلغاء'
    },
    'change-from-cash-to-debt':'هل أنت متأكد من تغيير نمط دفع الفاتورة؟ مع العلم أنه سيتم استبدال جميع المدفوعات السابقة ب مدفوعة واحدة بقيمة صافي الفاتورة',
    'change-from-debt-to-cash': 'هل أنت متأكد من تغيير نمط دفع الفاتورة؟ مع العلم انه سيتم حذف جميع المدفوعات السابقة',
    'payment-type': 'نمط الدفع',
    'payment-type-alert':'تغيير نمط الدفع',
    'all-categories': 'الكل',
    'cash': 'نقدية',
    'debt': 'آجلة',
    'export-payment-bond': 'تصدير إيصال دفع',
}